import { Link } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";

export default function CTA() {
  return (
    <section data-testid="cta-section" className="relative px-6 md:px-14 py-24 md:py-32 overflow-hidden border-b border-[#2A2A2A]">
      <div className="absolute inset-0 ww-radial-vermilion opacity-50 pointer-events-none" />
      <div className="absolute inset-0 ww-grid-bg opacity-25 pointer-events-none" />

      <div className="relative max-w-5xl">
        <div className="text-overline mb-6 text-[#FF4500]">◢ Tell us where it hurts</div>
        <h2 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.02]">
          You bring the problem.
          <br />
          We bring the <span className="text-[#FF4500]">system</span>.
        </h2>
        <p className="mt-5 text-[#8E8E93] text-[15px] leading-relaxed max-w-2xl">
          Two paths in: tell the AI Scoper your problem and get an outline in seconds,
          or use <b className="text-white">Start a project</b> in the top nav to reach the router.
        </p>

        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/scoper" data-testid="cta-scoper" className="btn-primary">
            <Sparkle size={14} weight="fill" /> Try the AI Scoper
          </Link>
        </div>
      </div>
    </section>
  );
}
